'use strict';
var Backbone = require('backbone');
var template = require('../../templates/countdown.ejs');
var _ = require('lodash');


module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-countdown',
    events: {
    },
    /**
     * Initialize Countdown View
     */
    initialize: function (options) {
        _.bindAll( this, 'render', 'update' );
        this.config = options.config;
        this.copyCms = options.copyCms;
        this.listenTo(this.model, 'change', this.update);
        this.listenTo(this.model, 'change:initialDuration', this.render);

        this.listenTo(this.copyCms, 'change:language', this.render);
    },
    /**
     * Render Countdown View
     */
    render: function () {
        const copy = this.copyCms.get('text').countdown;
        const model = _.extend({}, this.model.toJSON(), this.config, copy);
        
        this.$el.html(template(model));
        return this;
    },
    /**
     * [update description]
     * @return {[type]} [description]
     */
    update: function() {
        const { totalSecondsRemaining, minutesRemaining, secondsRemaining } = this.model.toJSON();
        const { minutes_label, seconds_label } = this.copyCms.get('text').countdown;
        const $timerEl = this.$('[role="timer"]');

        if(totalSecondsRemaining <= 60 && !this.$('.time').hasClass('blinker')) {
            this.$('.time').addClass('blinker');
        } else if(totalSecondsRemaining > 60) {
            this.$('.time').removeClass('blinker');
        }

        this.$('.seconds').text(secondsRemaining);
        this.$('.minutes').text(minutesRemaining);
        this.$('.screen-reader-text').text(`${minutesRemaining} ${minutes_label} ${secondsRemaining} ${seconds_label}`);
        
        // At 30 second intervals, set aria-busy to false to force screen readers to announce the time remaining
        if ($timerEl) {
            if (secondsRemaining % 30 === 0) {
                $timerEl.attr('aria-busy', 'false');
            } else {
                $timerEl.attr('aria-busy', 'true');
            }
        }  

    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/countdown.js